<template>
  <v-sheet>
    <v-row>
      <v-col cols="12" class="text-center mb-6">
        <div class="text-h5 font-weight-bold">Create New Tenant</div>
        <div class="text-subtitle">14-days free trial. No credit card required.</div>
      </v-col>
    </v-row>

    <v-row v-show="currentPage === 0">
      <v-text-field v-model="fullName" label="Full Name" outlined dense :rules="[rules.requiredField]" />
      <v-text-field :value="emailVerificationData.email" label="Email" outlined dense disabled />
      <v-text-field v-model="phone" label="Phone Number" outlined dense :rules="[rules.requiredField, rules.validPhone]" />
    </v-row>

    <v-row v-show="currentPage === 1">
      <v-text-field v-model="companyName" @blur="checkTenantName" label="Company Name" outlined dense :rules="[rules.requiredField]"/>
      <v-text-field v-model="tenantName" @blur="checkTenantName" label="Tenant Name" outlined dense :rules="[rules.requiredField]">
        <template #append>.systemx.net</template>
      </v-text-field>
      <v-text-field v-model="password" label="Password" outlined dense type="password" :rules="[rules.requiredField, rules.validPassword]"/>
    </v-row>

    <v-row v-show="currentPage === 2">
      <v-col cols="6" class="pa-0">
        <v-checkbox
          v-model="selectAllModules"
          label="Select All Modules"
          style="font-weight: bold"
          dense
          hide-details="auto"
          @change="onClickSelectAllModules"
        />
      </v-col>
      <v-col cols="6" v-for="module in modules" :key="module.id" class="pa-0">

        <v-checkbox
          v-model="selectedModules"
          :label="module.name"
          :value="module.id"
          dense
          hide-details="auto"
          @change="onModuleClicked"
        />

      </v-col>

      <div class="mt-3">
        <v-checkbox v-model="confirmToc" dense hide-hide-details="auto">
          <template #label>
            <div>
              <span class="font-weight-bold">IMPORTANT</span>:
              <span style="font-size: 11px;">
                By submitting this form, you are agreeing with
                <a @click.stop target="_blank" href="https://www.systemx.net/terms-of-service/">Terms Of Use</a>
                and
                <a @click.stop target="_blank" href="https://www.systemx.net/privacy-policy/">Privacy Policy</a> of SYSTEMX application.
              </span>
            </div>
          </template>
        </v-checkbox>
      </div>
    </v-row>

    <v-row>
      <v-col cols="6" class="pl-0">
        <v-btn color="#00F9A7" :disabled="previousIsDisabled" block @click="onClickPrevious">Previous</v-btn>
      </v-col>
      <v-col cols="6" class="pr-0">
        <v-btn color="#00F9A7" :disabled="nextIsDisabled" block @click="onClickNext">{{ currentPage === 2 ? 'Submit' : 'Next' }}</v-btn>
      </v-col>
    </v-row>

    <div class="mt-6">
      Already have an account? <a href="https://systemx.net/login">Log in</a>
    </div>

  </v-sheet>
</template>

<script>
import Bus from '@/bus';
export default {
  props: ['emailVerificationData'],
  data: () => ({
    currentPage: 0,
    fullName: '',
    phone: '',
    companyName: '',
    tenantName: '',
    password: '',
    selectedModules: [],
    selectAllModules: false,
    confirmToc: false,
    modules: [
      { id: 5, name: 'Project Management' },
      { id: 6, name: 'Timesheets' },
      { id: 2, name: 'Expense Reporting' },
      { id: 19, name: 'Invoicing' },
      { id: 10, name: 'Quoting' },
      { id: 14, name: 'Document Signing' },
      { id: 17, name: 'One Drive' },
      { id: 21, name: 'Human Resources' },
      { id: 20, name: 'Accounts Payable' },
      { id: 22, name: 'Time Off' },
      { id: 18, name: 'Bookings' },
      { id: 23, name: 'Subscriptions' },
      { id: 12, name: 'Purchase Orders' },
      { id: 13, name: 'Sales Orders' },
      { id: 24, name: 'Dashboard Insights' },
    ],

    rules: {
      requiredField: input => !!input || 'This field is required',
      validPhone: input => (input && input.length >= 10) || 'Please enter at least 10 characters',
      validPassword: input => (input && input.length >= 6) || 'Please enter at least 6 characters'
    }
  }),
  computed: {
    phoneIsValid() {
      return this.phone && this.phone.length >= 10;
    },
    previousIsDisabled() {
      return this.currentPage <= 0;
    },
    nextIsDisabled() {
      if (this.currentPage === 0) {
        return !this.fullName || !this.phone || !this.phoneIsValid;
      } else if (this.currentPage === 1) {
        return !this.companyName || !this.tenantName || !this.password;
      } else if (this.currentPage >= 2) return !this.confirmToc;
      return false;
    },
  },
  methods: {
    onClickPrevious() {
      this.currentPage--;
      if (this.currentPage < 0) this.currentPage = 0;
    },
    onClickNext() {
      if (this.currentPage < 2) this.currentPage++;
      else if (this.currentPage === 2) this.submit();
    },
    onModuleClicked() {
      this.selectAllModules = this.selectedModules.length === this.modules.length;
    },
    onClickSelectAllModules() {
      this.selectedModules = this.selectAllModules ? this.modules.map(x => x.id) : [];
    },
    async checkTenantName() {
      try {
        const data = {
          companyName: this.companyName,
          domainName: this.tenantName
        };
        //TODO this will need to use a different API url
        const res = await this.$api.post('/clients/tenant/available-domain-name', data);
        if (res) this.tenantName = res.data;
      } catch (e) {
        console.error(e);
      }
    },
    async submit() {
      if (!this.confirmToc) return;
      const data = {
        companyName: this.companyName,
        fullName: this.fullName,
        phoneNumber: this.phone,
        link: this.tenantName,
        email: this.emailVerificationData.email,
        password: this.password,
        modules: this.selectedModules,
        emailVerificationId: this.emailVerificationData.emailVerificationId,
      };
      try {
        Bus.$emit('loading', 'Please wait. This may take a few minutes');
        //TODO this will need to use a different API url
        const res = await this.$api.post(`/clients/tenant`, data);
        console.log(res);
        if (!res.data || res.status >= 400) {
          console.error('API Response:')
          console.error(res);
          throw new Error('Invalid API response');
        }
        Bus.$emit('alert', 'success', 'Tenant has been created successfully. Redirecting...');
        window.setTimeout(() => window.location.href = `https://${this.tenantName}.systemx.net`, 5000);
      } catch (e) {
        console.error(e);
        Bus.$emit('alert', 'error', 'Failed to sign up. Please contact support@systemx.net for assistance');
      } finally {
        Bus.$emit('loading');
      }
    }
  },
};
</script>

<style scoped>

</style>
